<a class="skip-to-content-link" href="#main" (click)="skipToContent($event, main)">Skip to main content</a>
<app-navigation></app-navigation>
<header>
  <div class="container">
    <img src="assets/images/seal.png" class="seal float-left d-none d-md-block" alt="seal of the state of hawaii">
    <div class="logo float-right d-none d-lg-block">
      <img src="assets/images/logo.png" alt="dar logo">
    </div>
    <span class="siteTitle">Online Dealer Reports</span>
    <span class="siteDept">Division of Aquatic Resources</span>
    <div class="clearfix"> </div>
  </div>
</header>
<div *ngIf="appSettings.testMode" class="container">
  <div class="row">
    <div class="col-lg-12">
      <div class="alert alert-danger alert-environment" role="region" aria-label="Test environment notice">
        <p class="m-1"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          This is the TEST instance of the web application. Please go to <a href="https://dlnr.ehawaii.gov/odr">https://dlnr.ehawaii.gov/odr</a>
          to file your dealer purchase report.
        </p>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <main #main class="mainContent" id="main" tabindex="-1">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</div>
<footer>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="footerContent">
          <div class="container">
            <div class="row">
              <div class="col-md-7">
                <span class="dept">Division of Aquatic Resources, <abbr title="Division of Aquatic Resources">DLNR</abbr></span>
                <a href="https://portal.ehawaii.gov/page/accessibility/" class="footerLink">Accessibility</a>
                <a routerLink="admin-login" class="footerLink">Admin Login</a>
                <a href="https://portal.ehawaii.gov/page/feedback/?applicationId=171" class="footerLink">Feedback </a>
                <a href="https://portal.ehawaii.gov/page/privacy-policy/" class="footerLink">Privacy</a>
                <a href="https://portal.ehawaii.gov/page/terms-of-use/" class="footerLink">Terms</a>
              </div>
              <div class="col-md-5 text-sm-left text-md-right">
                <app-copyright></app-copyright>
                <span class="poweredby">Powered by <a href="https://nichawaii.egov.com/" target="_blank">NIC Hawaii</a></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
